export default {
  "config": {
    "trial": "tones-3",
    "id": "ess-mitt",
    "type": "line",
    "title": "Change From Baseline of Epworth Sleepiness Scale (ESS) Scores Across Weeks<sup>23</sup>; Co-Primary Endpoint",
    "xAxis": {
      "groups": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ],
      "padding": 0.1,
      "label": {
        "text": "Week"
      },
      "overrides": {
        "0": "BL"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": -9,
      "high": 0,
      "inc": 1,
      "label": {
        "text": [
          "LS mean (SE) change",
          "from baseline, min"
        ]
      }
    },
    "legend": [
      {
        "entry": "pbo",
        "label": "Placebo <no-break>(n = 114)</no-break>",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo"
      },
      {
        "entry": "sol-375",
        "label": "Solriamfetol <no-break>37.5 mg</no-break> <no-break>(n = 56)</no-break>",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 37.5 mg"
      },
      {
        "entry": "sol-75",
        "label": "Solriamfetol <no-break>75 mg</no-break> <no-break>(n = 58)</no-break>",
        "color": "#ffce00",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 75 mg"
      },
      {
        "entry": "sol-150",
        "label": "Solriamfetol <no-break>150 mg</no-break> <no-break>(n = 116)</no-break>",
        "color": "#73cac3",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 150 mg"
      },
      {
        "entry": "sol-300",
        "label": "Solriamfetol <no-break>300 mg</no-break> <no-break>(n = 115)</no-break>",
        "color": "#be5b92",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 300 mg"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<no-break>*<em>P</em> < 0.05</no-break> vs placebo;<no-break> <sup>#</sup><em>P</em> < 0.0001</no-break> vs placebo."
    ],
    "useFootnoteTooltip": false,
    "trendLines": [],
    "tooltipHeaders": [
      "Treatment group",
      "min"
    ],
    "nValueTable": {
      "type": "regular",
      "rows": 1,
      "sourceField": "y"
    },
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo",
            "label": "Placebo <no-break>(n = 114)</no-break>",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-375",
            "label": "Solriamfetol <no-break>37.5 mg</no-break> <no-break>(n = 56)</no-break>",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 37.5 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-75",
            "label": "Solriamfetol <no-break>75 mg</no-break> <no-break>(n = 58)</no-break>",
            "color": "#ffce00",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 75 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-150",
            "label": "Solriamfetol <no-break>150 mg</no-break> <no-break>(n = 116)</no-break>",
            "color": "#73cac3",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 150 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-300",
            "label": "Solriamfetol <no-break>300 mg</no-break> <no-break>(n = 115)</no-break>",
            "color": "#be5b92",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 300 mg"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "name": "pbo",
      "color": "#868686",
      "sets": [
        {
          "name": "pbo",
          "color": "#868686",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Placebo, LS mean",
          "tooltipLabel": "Placebo",
          "points": [
            {
              "x": 0,
              "y": 0,
              "extreme": {
                "upper": 0,
                "lower": 0
              },
              "label": {
                "text": 0,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 1,
              "y": -2.6,
              "extreme": {
                "upper": 0.47,
                "lower": 0.47
              },
              "label": {
                "text": -2.6,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": -2.9,
              "extreme": {
                "upper": 0.45,
                "lower": 0.45
              },
              "label": {
                "text": -2.9,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 6,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 7,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 8,
              "y": -3.8,
              "extreme": {
                "upper": 0.49,
                "lower": 0.49
              },
              "label": {
                "text": -3.8,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 9,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 10,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 11,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 12,
              "y": -3.3,
              "extreme": {
                "upper": 0.45,
                "lower": 0.45
              },
              "label": {
                "text": -3.3,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-375",
      "color": "#006e8a",
      "sets": [
        {
          "name": "sol-375",
          "color": "#006e8a",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 37.5 mg, LS mean",
          "tooltipLabel": "Solriamfetol 37.5 mg",
          "points": [
            {
              "x": 0,
              "y": 0,
              "extreme": {
                "upper": 0,
                "lower": 0
              },
              "label": {
                "text": 0,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 1,
              "y": -4.5,
              "extreme": {
                "upper": 0.66,
                "lower": 0.66
              },
              "label": {
                "text": -4.5,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": -4.7,
              "extreme": {
                "upper": 0.65,
                "lower": 0.65
              },
              "label": {
                "text": -4.7,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 6,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 7,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 8,
              "y": -4.7,
              "extreme": {
                "upper": 0.7,
                "lower": 0.7
              },
              "label": {
                "text": -4.7,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 9,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 10,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 11,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 12,
              "y": -5.1,
              "extreme": {
                "upper": 0.64,
                "lower": 0.64
              },
              "label": {
                "text": -5.1,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-75",
      "color": "#ffce00",
      "sets": [
        {
          "name": "sol-75",
          "color": "#ffce00",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 75 mg, LS mean",
          "tooltipLabel": "Solriamfetol 75 mg",
          "points": [
            {
              "x": 0,
              "y": 0,
              "extreme": {
                "upper": 0,
                "lower": 0
              },
              "label": {
                "text": 0,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 1,
              "y": -4.4,
              "extreme": {
                "upper": 0.65,
                "lower": 0.65
              },
              "label": {
                "text": -4.4,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": -4.8,
              "extreme": {
                "upper": 0.63,
                "lower": 0.63
              },
              "label": {
                "text": -4.8,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 6,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 7,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 8,
              "y": -6.3,
              "extreme": {
                "upper": 0.67,
                "lower": 0.67
              },
              "label": {
                "text": -6.3,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 9,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 10,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 11,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 12,
              "y": -5,
              "extreme": {
                "upper": 0.62,
                "lower": 0.62
              },
              "label": {
                "text": -5,
                "sup": "*",
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-150",
      "color": "#73cac3",
      "sets": [
        {
          "name": "sol-150",
          "color": "#73cac3",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 150 mg, LS mean",
          "tooltipLabel": "Solriamfetol 150 mg",
          "points": [
            {
              "x": 0,
              "y": 0,
              "extreme": {
                "upper": 0,
                "lower": 0
              },
              "label": {
                "text": 0,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 1,
              "y": -5.5,
              "extreme": {
                "upper": 0.46,
                "lower": 0.46
              },
              "label": {
                "text": -5.5,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": -6.1,
              "extreme": {
                "upper": 0.45,
                "lower": 0.45
              },
              "label": {
                "text": -6.1,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 6,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 7,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 8,
              "y": -6.9,
              "extreme": {
                "upper": 0.48,
                "lower": 0.48
              },
              "label": {
                "text": -6.9,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 9,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 10,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 11,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 12,
              "y": -7.7,
              "extreme": {
                "upper": 0.44,
                "lower": 0.44
              },
              "label": {
                "text": -7.7,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "sol-300",
      "color": "#be5b92",
      "sets": [
        {
          "name": "sol-300",
          "color": "#be5b92",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol 300 mg, LS mean",
          "tooltipLabel": "Solriamfetol 300 mg",
          "points": [
            {
              "x": 0,
              "y": 0,
              "extreme": {
                "upper": 0,
                "lower": 0
              },
              "label": {
                "text": 0,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 1,
              "y": -6.6,
              "extreme": {
                "upper": 0.46,
                "lower": 0.46
              },
              "label": {
                "text": -6.6,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 4,
              "y": -6.6,
              "extreme": {
                "upper": 0.46,
                "lower": 0.46
              },
              "label": {
                "text": -6.6,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 5,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 6,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 7,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 8,
              "y": -7.7,
              "extreme": {
                "upper": 0.5,
                "lower": 0.5
              },
              "label": {
                "text": -7.7,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 9,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 10,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 11,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 12,
              "y": -7.9,
              "extreme": {
                "upper": -0.46,
                "lower": -0.46
              },
              "label": {
                "text": -7.9,
                "sup": "#",
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    }
  ]
};